import {useFormik} from 'formik'
import SharedModal from '../../../sharedComponent/SharedModal'
import TextField from '../../../sharedComponent/TextField/TextField'
import {useMutation} from '@apollo/client'
import {UPDATE_AGENT_LEADER} from '../../../../utils/GraphQLAPI'
import {alert} from '../../../../utils/helper'
import ToggleButton from '../../../sharedComponent/ToggleButton'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import * as Yup from 'yup'
type EditAgentLeaderType = {
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
  editAgentLeaderValues: {
    leaderName: string | null
    leaderCode: string | null
    leaderStatus: boolean
    leaderId: string | null
  }
  handleModalClose: () => void
}
const EditAgentLeader = ({editAgentLeaderValues, handleModalClose}: EditAgentLeaderType) => {
  const [updateAgentLeader] = useMutation(UPDATE_AGENT_LEADER, {
    onCompleted: () => {
      alert('Agent Leader updated successfully', 'success')
      handleModalClose()
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  const editAgentFormik = useFormik({
    initialValues: editAgentLeaderValues,
    validationSchema: Yup.object().shape({
      leaderName: Yup.string().required('Agent Leader Name is required'),
      leaderCode: Yup.string().required('Agent Leader Code is required'),
    }),
    onSubmit: (values) => {
      updateAgentLeader({
        variables: {
          updateAgentLeaderInputs: values,
        },
      })
    },
  })

  return (
    <SharedModal
      headerName='Agent Name'
      show={true}
      handleClose={handleModalClose}
      handleSubmit={() => editAgentFormik.submitForm()}
      className='modal-dialog-centered mw-650px'
      headerContent={
        <ToggleButton
          leftText='Inactive'
          rightText='Active'
          leftTextClassName='badge-light-danger'
          rightTextClassName='badge-light-success'
          isActive={editAgentFormik.values.leaderStatus}
          onChange={(checked) => editAgentFormik.setFieldValue('leaderStatus', checked)}
        />
      }
    >
      <div className='p-5'>
        <TextField
          fieldName='leaderName'
          filedTitleMandatory={true}
          fieldTitle='Agent Leader Name'
          formik={editAgentFormik}
        />
        <TextField
          fieldName='leaderCode'
          filedTitleMandatory={true}
          fieldTitle='Agent Leader Code'
          formik={editAgentFormik}
        />
      </div>
    </SharedModal>
  )
}
export default EditAgentLeader
